import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Boxes = () => {
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };
  return (
    <>
      <Slider className="block lg:hidden" {...settings}>
        <div className="xs:h-[360px] sm:h-[340px] xmd:h-[320px] smh-[280px] bg-primary order-1 p-12 lg:p-20 box-border">
          <div>
            <h1 className="text-3xl h-10 lg:text-5xl font-bold uppercase text-white">
              Physical meets digital
            </h1>
            <p className="text-white mt-16 text-xs lg:text-base">
              There hasn’t been a transparent, easy way to invest in sports
              until now. We partner with the sports teams to tokenize ownership
              and issue tokens in the form of shares via an Initial Public
              Offering (IPO)
            </p>
            <p className="mt-8 text-white text-xs lg:text-base">
              Let’s play together as a team to make fractional ownership
              accessible for all, not just the top dogs.
            </p>
          </div>
        </div>
        <div className="xs:h-[360px] sm:h-[340px] xmd:h-[320px] smh-[280px] bg-secondary order-2 p-12 lg:p-20 box-border">
          <h1 className="text-3xl h-10 lg:text-5xl font-bold uppercase text-white">
            TOKENIZATION OF AN ASSET
          </h1>
          <p className="text-white mt-16 text-xs lg:text-base">
            Via asset tokenization we create digital tokens on a distributed
            ledger or blockchain, which represents the digital ownership of a
            physical sports team.
          </p>
          <p className="mt-8 text-white text-xs lg:text-base">
            In simple terms, after regulatory qualifications, we shift an
            Off-Chain asset (physical) to an On-Chain digital blockchain
            network.
          </p>
        </div>
        <div className="xs:h-[360px] sm:h-[340px] xmd:h-[320px] smh-[280px] bg-secondary order-3 p-12 lg:p-20 box-border">
          <h1 className="text-3xl h-10 lg:text-5xl font-bold uppercase text-white">
            INTRINSIC VALUE of an athlete
          </h1>
          <p className="text-white mt-16 text-xs lg:text-base">
            Each team roster is placed into our proprietary algorithm to
            calculate the intrinsic value of an athlete based on the real game
            stats, player importance and impact on wins.
          </p>
          <p className="mt-8 text-white text-xs lg:text-base">
            After that, via our secure portal a qualified investor can buy
            shares of each athlete to build their ownership in a specific sports
            team.
          </p>
        </div>
        <div className="xs:h-[360px] sm:h-[340px] xmd:h-[320px] smh-[280px] bg-primary order-4 p-12 lg:p-20 box-border">
          <h1 className="text-3xl h-10 lg:text-5xl font-bold uppercase text-white">
            work in progress
          </h1>
          <p className="text-white mt-16 text-xs lg:text-base">
            Currently, we’re in beta and actively working towards a partnership
            with many sports leagues such as National Basketball Association,
            National Football League, National Hockey League, Major Soccer
            League, Major League Pickleball, etc.
          </p>
          <p className="mt-8 text-white text-xs lg:text-base">
            Stay tuned for announcements.
          </p>
        </div>
      </Slider>
      <div className="hidden relative lg:grid h-[660px] lg:h-[560px] xl:h-[480px]">
        <div className="absolute h-full top-0 left-0 md:grid grid-cols-1 lg:grid-cols-2 w-full">
          <div className="bg-primary h-full"></div>
          <div className="bg-secondary h-full"></div>
        </div>
        <div className="absolute h-full lg:h-auto w-10/12 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid grid-cols-1 lg:grid-cols-2 font-poppins">
          <div className="bg-primary flex items-center lg:block order-1 box-border lg:pr-16">
            <div>
              <h1 className="text-3xl  h-14 lg:text-5xl font-bold uppercase text-white">
                Physical meets digital
              </h1>
              <p className="text-white mt-4 md:mt-16 text-xs lg:text-base">
                There hasn’t been a transparent, easy way to invest in sports
                until now. We partner with the sports teams to tokenize
                ownership and issue tokens in the form of shares via an Initial
                Public Offering (IPO)
              </p>
              <p className="mt-8 text-white text-xs lg:text-base">
                Let’s play together as a team to make fractional ownership
                accessible for all, not just the top dogs.
              </p>
            </div>
          </div>
          <div className="bg-secondary flex items-center lg:block  order-2 box-border lg:pl-16">
            <div>
              <h1 className="text-3xl  h-14 lg:text-5xl font-bold uppercase text-white">
                TOKENIZATION OF AN ASSET
              </h1>
              <p className="text-white mt-4 md:mt-16 text-xs lg:text-base">
                Via asset tokenization we create digital tokens on a distributed
                ledger or blockchain, which represents the digital ownership of
                a physical sports team.
              </p>
              <p className="mt-8 text-white text-xs lg:text-base">
                In simple terms, after regulatory qualifications, we shift an
                Off-Chain asset (physical) to an On-Chain digital blockchain
                network.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden relative lg:grid h-[660px] lg:h-[560px] xl:h-[480px]">
        <div className="absolute h-full top-0 left-0 md:grid grid-cols-1 lg:grid-cols-2 w-full">
          <div className="bg-primary lg:bg-secondary"></div>
          <div className="bg-secondary lg:bg-primary"></div>
        </div>
        <div className="absolute h-full lg:h-auto w-10/12 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid grid-cols-1 lg:grid-cols-2 font-poppins">
          <div className="bg-secondary flex items-center lg:block order-1 box-border lg:pr-16">
            <div>
              <h1 className="text-3xl h-14 lg:text-5xl font-bold uppercase text-white">
                INTRINSIC VALUE OF AN ATHLETE
              </h1>
              <p className="text-white mt-4 md:mt-16 text-xs lg:text-base">
                Each team roster is placed into our proprietary algorithm to
                calculate the intrinsic value of an athlete based on the real
                game stats, player importance and impact on wins.
              </p>
              <p className="mt-8 text-white text-xs lg:text-base">
                After that, via our secure portal a qualified investor can buy
                shares of each athlete to build their ownership in a specific
                sports team.
              </p>
            </div>
          </div>
          <div className="bg-primary flex items-center lg:block order-2 box-border lg:pl-16">
            <div>
              <h1 className="text-3xl h-14 lg:text-5xl font-bold uppercase text-white">
                WORK IN PROGRESS
              </h1>
              <p className="text-white mt-4 md:mt-16 text-xs lg:text-base">
                Currently, we’re in beta and actively working towards a
                partnership with many sports leagues such as National Basketball
                Association, National Football League, National Hockey League,
                Major Soccer League, Major League Pickleball, etc.
              </p>
              <p className="mt-8 text-white text-xs lg:text-base">
                Stay tuned for announcements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Boxes;
